import { Tag } from 'antd'
import { FC, useContext } from 'react'
import { css, styled } from 'styled-components'
import Task, { TaskStatuses } from '../../../../../types/api/task'
import { DesignerTasksScaleContext } from '../../../constants/scale-context'

const TagStyled = styled(Tag)<{ $isLarge: boolean }>`
    margin: 0;

    ${({ $isLarge }) =>
        $isLarge &&
        css`
            font-size: 16px;
            padding: 2px 8px;
        `}
`

interface TaskStatusCellProps {
    taskStatus?: Task['taskStatus']
}

const taskStatusColor: Partial<Record<TaskStatuses, string>> = {
    Новая: 'default',
    'В работе': 'blue',
    Завершена: 'green',
    Отменена: 'red',
}

const TaskStatusCell: FC<TaskStatusCellProps> = ({ taskStatus }) => {
    const isLarge = useContext(DesignerTasksScaleContext) === 'large'

    if (!taskStatus) return null

    const color = taskStatusColor[taskStatus as TaskStatuses] ?? 'default'

    return <TagStyled color={color} $isLarge={isLarge}>{taskStatus}</TagStyled>
}

export default TaskStatusCell
